"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _marketing = require("@/api/marketing");

var _index2 = require("@/utils/index");

var _permission = require("@/utils/permission");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// 权限判断函数
var _default = {
  name: "index",
  filters: {
    formatDate: function formatDate(time) {
      if (time !== 0) {
        var date = new Date(time);
        return (0, _index2.formatDates)(date, 'yyyy-MM-dd hh:mm');
      }
    }
  },
  data: function data() {
    return {
      tableFrom: {
        page: 1,
        limit: 20,
        keywords: '',
        isShow: ''
      },
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //导出
    exportList: function exportList() {
      (0, _marketing.exportcombiantionApi)({
        keywords: this.tableFrom.keywords,
        isShow: this.tableFrom.isShow
      }).then(function (res) {
        // window.open(res.fileName)
        window.location.href = res.fileName;
      });
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this = this;

      this.$modalSure().then(function () {
        (0, _marketing.combinationDeleteApi)({
          id: id
        }).then(function () {
          _this.$message.success('删除成功');

          _this.tableData.data.splice(idx, 1);
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this2 = this;

      (0, _marketing.combinationStatusApi)({
        id: row.id,
        isShow: row.isShow
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee() {
        return _index.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.$message.success('修改成功');

                _this2.getList();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    // 列表
    getList: function getList(num) {
      var _this3 = this;

      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _marketing.combinationListApi)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.list;
        _this3.tableData.total = res.total;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};
exports.default = _default;